import store from '../../../helpers/store';
import { DEVICE, DISPLAY } from '../../main/types';
import { VIEWS, VIEW_MODES } from '../../views/types';

export const getWidgetDisplay = (view, mode) => {
    let widgetDisplay = DISPLAY.STANDARD;

    const state = store.getState();

    if (state.settings.widget && state.settings.widget.fullscreen) {
        return DISPLAY.FULLSCREEN;
    }

    if (!view) {
        view = state.widget.currentView;
    }

    if (!mode) {
        mode = state.widget.currentMode;
    }

    switch (state.main.device) {
        case DEVICE.DESKTOP:
            break;
        case DEVICE.MOBILE:
            switch (view.toUpperCase()) {
                case VIEWS.CONTACT:
                    widgetDisplay = DISPLAY.STANDARD;
                    break;
                default:
                    if (mode === VIEW_MODES.MINIMIZED) {
                        widgetDisplay = DISPLAY.STANDARD;
                    } else {
                        widgetDisplay = DISPLAY.FULLSCREEN;
                    }
                    break;
            }
            break;
        default:
            break;
    }

    return widgetDisplay;
};
